"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleChartColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var pointsChart_1 = require("../_chartColoring/pointsChart");
var BubbleChartColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleChartColorStrategy, _super);
    function BubbleChartColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubbleChartColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute, dv) {
        var colorAssignment;
        if (stackByAttribute) {
            colorAssignment = _super.prototype.createColorAssignment.call(this, colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv).fullColorAssignment;
        }
        else {
            colorAssignment = this.singleMeasureColorMapping(colorPalette, colorMapping, dv);
        }
        return {
            fullColorAssignment: colorAssignment,
        };
    };
    BubbleChartColorStrategy.prototype.createPalette = function (colorPalette, colorAssignment, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute) {
        if (stackByAttribute) {
            return _super.prototype.createPalette.call(this, colorPalette, colorAssignment, viewByAttribute, stackByAttribute);
        }
        return _super.prototype.createSingleColorPalette.call(this, colorPalette, colorAssignment, stackByAttribute);
    };
    return BubbleChartColorStrategy;
}(pointsChart_1.PointsChartColorStrategy));
exports.BubbleChartColorStrategy = BubbleChartColorStrategy;
//# sourceMappingURL=bubbleChartColoring.js.map